import {GetStoreServicesOrdersApiResponse} from "../../../../react-query-hooks/store/services/get-orders/types";

export type SetSelectedStoreServiceOrderInfoPayload = {
  deliveredWork: {
    key: string;
    isUpload: boolean;
  }[];
} & GetStoreServicesOrdersApiResponse["orders"][0];

type UpdateStatusId = {
  type: "update-status-id";
  payload: number;
};
type UpdateCurrentPage = {
  type: "update-current-page";
  payload: number;
};
type UpdatePerPage = {
  type: "update-per-page";
  payload: number;
};
type SetSelectedStoreServiceOrderInfo = {
  type: "set-selected-store-service-order-info";
  payload: SetSelectedStoreServiceOrderInfoPayload | null;
};
type SetActiveStoreServiceOrderDrawer = {
  type: "set-active-store-service-order-drawer";
  payload: "order-info" | "deliver-work" | null;
};

export type GetStoreServicesOrdersReducerActions =
  | UpdateStatusId
  | UpdateCurrentPage
  | UpdatePerPage
  | SetActiveStoreServiceOrderDrawer
  | SetSelectedStoreServiceOrderInfo;

export type GetStoreServicesOrdersReducerState = {
  currentPage: number;
  per_page: number;
  statusId: number;
  selectedStoreServiceOrderInfo: SetSelectedStoreServiceOrderInfoPayload | null;
  activeStoreServiceOrderDrawer: "order-info" | "deliver-work" | null;
};

export const initialGetStoreServicesOrdersReducerState: GetStoreServicesOrdersReducerState =
  {
    currentPage: 1,
    per_page: 5,
    statusId: -1,
    selectedStoreServiceOrderInfo: null,
    activeStoreServiceOrderDrawer: null,
  };

// export function createInitialGetStoreServicesOrdersFormReducerStateFromApi(args: {
//   orders: GetStoreServicesOrdersApiResponse["orders"];
//   paginationMeta: PaginationMeta;
// }): GetStoreServicesOrdersReducerState {
//   return {
//     currentPage: 1,
//     per_page: 5,
//     statusId: 4,
//     orders: args.orders,
//     paginationMeta: args.paginationMeta,
//     isPreviousData: false,
//     isLoading: false,
//   };
// }

export const getStoreServicesOrdersFormReducer = (
  state: GetStoreServicesOrdersReducerState = initialGetStoreServicesOrdersReducerState,
  action: GetStoreServicesOrdersReducerActions
) => {
  if (action.type === "update-status-id") {
    return {...state, statusId: action.payload, currentPage: 1};
  }
  if (action.type === "update-current-page") {
    return {...state, currentPage: action.payload};
  }
  if (action.type === "update-per-page") {
    return {...state, per_page: action.payload};
  }
  if (action.type === "set-selected-store-service-order-info") {
    return {...state, selectedStoreServiceOrderInfo: action.payload};
  }
  if (action.type === "set-active-store-service-order-drawer") {
    return {...state, activeStoreServiceOrderDrawer: action.payload};
  }
  //   if (action.type === "reset-state") {
  //     return {...initialCreateProductFormState};
  //   }

  return state;
};
